import { useState } from 'react';

const useDoubleClick = (doubleClickTime = 300) => {
	const [clickTimeout, setClickTimeout] = useState(null);

	const isDoubleClick = async () => {
		if (clickTimeout) {
			clearTimeout(clickTimeout);
			setClickTimeout(null);
			return true;
		}

		const timeout = setTimeout(() => {
			setClickTimeout(null);
		}, doubleClickTime);

		setClickTimeout(timeout);
		return false;
	};

	return isDoubleClick;
};

export default useDoubleClick;
